'use strict';
const ParameterNames = {
  PRM_NAME_CLIENT:                    'prmNomeCliente',
  PRM_SIGLA_CLIENT:                   'prmSiglaCliente',
  PRM_UF_CLIENT:                      'prmUfCliente',
  PRM_SHOW_CUMMUNITY_ASSERTS:         'prmUtilizaBemPublico',
  PRM_SHOW_ENTERPRISE:                'prmUtilizaEmpreendimento',
  PRM_SHOW_INFO_FINANCIAL:            'prmExibeInfoFinancMapa',
  PRM_SHOW_FINANCIAL_RESUME_CONTRACT: 'prmExibeResumoFinanceiroContratoMapa',
  PRM_SHOW_FINANCIAL_RESUME_COVENANT: 'prmExibeResumoFinanceiroConvenioMapa',
  PRM_FILTROS:                        'prmMapaObrasFiltros',
  PRM_SHOW_CONTRACT_ONLOAD_MAP:       'prmExibeTelaContratoCarregarMapaObras'
};
export default ParameterNames



// WEBPACK FOOTER //
// ./src/app/scripts/constants/parameters.js